import type { OrderDetail } from '../../lib/orders';
import { PhoneNumber } from '../phone/PhoneNumber';

interface Props {
  order: OrderDetail;
}

function renderAddress(formatted: string) {
  if (!formatted) return null;
  const lines = formatted.split(/<br\s*\/?>/i).map((s) => s.trim()).filter(Boolean);
  return lines.map((line, i) => (
    <span key={i} className="block">{line}</span>
  ));
}

export function CustomerContextHeader({ order }: Props) {
  const itemCount = order.items.reduce((sum, g) => sum + 1 + g.extras.length, 0);
  // NIET vermenigvuldigen met quantity: bij een kleed per m² draagt Aantal__c
  // de oppervlakte (order-panel-store zet qty = ceil(m²) bij het prijzen), dus
  // areaM2 * quantity kwadrateert. 3.304 van de 3.333 kleed-items uit de laatste
  // 90 dagen hadden Aantal__c exact gelijk aan Oppervlakte_m__c: gemiddeld toonde
  // deze header 34,0 m² waar 5,2 m² klopte. Voor de 26 items met aantal 1 is de
  // som identiek, dus de vermenigvuldiging voegde nergens iets toe.
  const totalM2 = order.items.reduce((sum, g) => sum + (g.primary.areaM2 ?? 0), 0);

  return (
    <div className="px-5 py-3 bg-slate-50 border-b border-slate-200 space-y-1.5">
      <div className="flex items-center gap-2 flex-wrap">
        <span className="text-xs font-mono text-slate-500">{order.orderNumber}</span>
        {order.customer.name && (
          <span className="text-sm font-medium text-slate-900">{order.customer.name}</span>
        )}
      </div>

      <div className="flex items-center gap-3 text-xs text-slate-600">
        {order.customer.phone && (
          <PhoneNumber
            number={order.customer.phone}
            customerName={order.customer.name}
            sourceContext="afspraak-header"
            className="hover:text-indigo-600"
          />
        )}
        {order.customer.mobile && order.customer.mobile !== order.customer.phone && (
          <PhoneNumber
            number={order.customer.mobile}
            display={order.customer.mobile}
            customerName={order.customer.name}
            sourceContext="afspraak-header"
            className="hover:text-indigo-600"
          />
        )}
      </div>

      {order.addresses.pickup.formatted && (
        <div className="text-xs text-slate-500">
          {renderAddress(order.addresses.pickup.formatted)}
        </div>
      )}

      <div className="text-xs text-slate-500">
        {itemCount} item{itemCount === 1 ? '' : 's'}
        {totalM2 > 0 && <> · {totalM2.toFixed(1)} m²</>}
      </div>
    </div>
  );
}
